// Mock data arrays for landing page target type examples
// Using static URLs to avoid API calls on the landing page

export const imageTargets = [
  {
    url: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop",
    alt: "Mountain landscape at sunset",
  },
  {
    url: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&h=400&fit=crop",
    alt: "Tropical beach with clear water",
  },
  {
    url: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=600&h=400&fit=crop",
    alt: "Urban city skyline at dusk",
  },
  {
    url: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=600&h=400&fit=crop",
    alt: "Sunlight through forest trees",
  },
  {
    url: "https://images.unsplash.com/photo-1682687220742-aba13b6e50ba?w=600&h=400&fit=crop",
    alt: "Desert sand dunes",
  },
  {
    url: "https://images.unsplash.com/photo-1433086966358-54859d0ed716?w=600&h=400&fit=crop",
    alt: "Waterfall in lush greenery",
  },
];

export const predictionTargets = [
  {
    optionA: {
      url: "https://images.unsplash.com/photo-1601134467661-3d775b999c8b?w=300&h=200&fit=crop",
      label: "Yes",
    },
    optionB: {
      url: "https://images.unsplash.com/photo-1534088568595-a066f410bcda?w=300&h=200&fit=crop",
      label: "No",
    },
  },
  {
    optionA: {
      url: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop",
      label: "Yes",
    },
    optionB: {
      url: "https://images.unsplash.com/photo-1534274988757-a28bf1a57c17?w=300&h=200&fit=crop",
      label: "No",
    },
  },
  {
    optionA: {
      url: "https://images.unsplash.com/photo-1504701954957-2010ec3bcec1?w=300&h=200&fit=crop",
      label: "Yes",
    },
    optionB: {
      url: "https://images.unsplash.com/photo-1516912481808-3406841bd33c?w=300&h=200&fit=crop",
      label: "No",
    },
  },
  {
    optionA: {
      url: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=300&h=200&fit=crop",
      label: "Yes",
    },
    optionB: {
      url: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=300&h=200&fit=crop",
      label: "No",
    },
  },
];

export const locationTargets = [
  {
    label: "Paris, France",
    embedUrl: "https://www.google.com/maps/embed?pb=!4v1704067200000!6m8!1m7!1sCbLQOyp2J6dZ5NJPFK_L6g!2m2!1d48.85836929999999!2d2.2944813!3f280!4f0!5f0.7820865974627469",
  },
  {
    label: "New York, USA",
    embedUrl: "https://www.google.com/maps/embed?pb=!4v1704067200000!6m8!1m7!1sCAoSLEFGMVFpcE1lTFhBMVRnRXM0a3BfbmVMaEFxNnRGYXhZLWNfMjNWUkxFOVNn!2m2!1d40.758896!2d-73.985130!3f0!4f0!5f0.7820865974627469",
  },
  {
    label: "Tokyo, Japan",
    embedUrl: "https://www.google.com/maps/embed?pb=!4v1704067200000!6m8!1m7!1sCAoSLEFGMVFpcE1GdXVVRmVXOWVFWEozaHJCSWpGbFNNVjBHSlRYZUNwUEFXN29L!2m2!1d35.6595!2d139.7004!3f0!4f0!5f0.7820865974627469",
  },
  {
    label: "Rome, Italy",
    embedUrl: "https://www.google.com/maps/embed?pb=!4v1704067200000!6m8!1m7!1sCAoSLEFGMVFpcE9nNHlOY0dMX2RxWEVzOGlKU1o1dWVQUXdHckFBTVpWOVBfOHNE!2m2!1d41.8902!2d12.4922!3f0!4f0!5f0.7820865974627469",
  },
  {
    label: "Sydney, Australia",
    embedUrl: "https://www.google.com/maps/embed?pb=!4v1704067200000!6m8!1m7!1sCAoSLEFGMVFpcE5YOXZIZnN0WEVfX3ZlVW5uRFBnVWk2bkpfMjRnZjBpT2k4Q0Fz!2m2!1d-33.8568!2d151.2153!3f0!4f0!5f0.7820865974627469",
  },
];

// Legacy export for backwards compatibility (uses first item from each array)
export const mockTargetData = {
  image: {
    url: imageTargets[0].url,
    alt: imageTargets[0].alt,
    credit: "Photo by Unsplash"
  },
  location: {
    fallbackUrl: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&h=400&fit=crop",
    label: locationTargets[0].label,
    coordinates: { lat: 48.858844, lng: 2.294351 }
  },
  prediction: {
    optionA: predictionTargets[0].optionA,
    optionB: predictionTargets[0].optionB,
    question: "Will this event occur?"
  }
};
